export default __webpack_public_path__ + "static/media/Mail.a38033ec.svg";